import { Navigate, Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./sidebar";
import { CURRENT_USER_LOGIN_STATUS } from "../../utils/constants";
import { useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";

import useApi from "../../utils/useApi";
import BreadcrumbNav from "./BreadCrumbNav";
import { API_PATHS } from "../../utils/constants";
import { useNavigate } from "react-router-dom";

import { getAllMenuModulePathAndLogo } from "../../utils/MenuModulePathAndLogoListOfThisProduct";

import { motion } from "motion/react";
import ic_no_logo from "../../img/ic_no_module_image.png";
import AutoLogoutAndGuard from '../../utils/AutoLogout'
const ProtectedRouteLogin = () => {
  const prevRoute = sessionStorage.getItem("previousRoute");
  const [isModulePanelExpanded, setIsModulePanelExpanded] = useState(false);

  const navigate = useNavigate();

  const COMPANY_CODE = localStorage.getItem("companyCode");

  const menu_list = getAllMenuModulePathAndLogo();

  const [groupedModuleSubmoduleMain, setGroupedModuleSubmoduleMain] =
    useState(null);
  const {
    data: datagetAllMenuOfThisRole,
    loading: loadinggetAllMenuOfThisRole,
    error: errorgetAllMenuOfThisRole,
    get: getAllMenuOfThisRole,
  } = useApi();
  const [current_role_of_logged_in_user, setCurrent_role_of_logged_in_user] =
    useState(null);
  const [currentSelectedMouleObject, setCurrentSelectedMouleObject] =
    useState(null);
  const [pathArray, setPathArray] = useState(null);
  const [currentHoveredLink, setCurrentHoveredLink] = useState("");
  const [currentHoveredLinkPositon, setCurrentHoveredLinkPositon] =
    useState(null);

  const location = useLocation();

  const [currentPathName, setCurrentPathName] = useState(null);

  let token = false;

  const loginStatus = JSON.parse(
    localStorage.getItem("currentUserLoginStatus")
  );

  if (loginStatus) {
    token = true;
  }

  useEffect(() => {
    // console.log("loc", location.pathname);
    setCurrentPathName(location.pathname);
    getRoleOfUser();
  }, []);

  // useEffect(() => {
  //   console.log("currentSelectedMouleObject []", currentSelectedMouleObject);
  // }, [currentSelectedMouleObject]);

  useEffect(() => {
    // console.log(
    //   "inside useEffect [location] ProtectedRouteMachine",
    //   location.pathname
    // );

    setCurrentPathName(location.pathname);
  }, [location]);

  useEffect(() => {
    // console.log("currentHoveredLinkPositon ", currentHoveredLinkPositon);
    const rect = currentHoveredLinkPositon?.target.getBoundingClientRect();
    // console.log("currentHoveredLinkPositon rect>>>>>>>", rect);
  }, [currentHoveredLinkPositon]);

  useEffect(() => {
    if (currentPathName) {
      const pathArraySplit = location.pathname?.split("/");
      // console.log("pathArray ", pathArraySplit);
      setPathArray(pathArraySplit);
    }
  }, [currentPathName]);

  const breadcrumbs = [
    { label: "page1", path: "/page1" },
    { label: "page2", path: "/page1/page2" },
    { label: "page3", path: "/page1/page2/page3" }, // current page
  ];

  const getRoleOfUser = () => {
    const currentUserObject = JSON.parse(localStorage?.getItem("currentUser"));

    const userAccessGroup = currentUserObject[0]?.accessgrp;

    setCurrent_role_of_logged_in_user(userAccessGroup?.trim()?.toUpperCase());
  };

  useEffect(() => {
    if (current_role_of_logged_in_user) {
      let apiurl = `https://cubixweberp.com:213/api/ClientRoleMenuControl/${COMPANY_CODE}/${COMPANY_CODE}/${current_role_of_logged_in_user}/MAINMENU/-`;

      // console.log("apiurl current_role_of_logged_in_user", apiurl);

      getAllMenuOfThisRole(apiurl);
    }
  }, [current_role_of_logged_in_user]);

  useEffect(() => {
    if (datagetAllMenuOfThisRole) {
      // console.log("datagetAllMenuOfThisRole ", datagetAllMenuOfThisRole);

      const grouped = [];

      datagetAllMenuOfThisRole.forEach((item) => {
        // Find or create module
        let module = grouped.find((m) => m.MODULEID === item.MODULEID);
        if (!module) {
          module = {
            MODULEID: item.MODULEID,
            MODULENAME: item.MODULENAME,
            SUBMODULES: [],
          };
          grouped.push(module);
        }

        // Find or create submodule
        let submodule = module.SUBMODULES.find(
          (sm) => sm.SUBMODULEID === item.SUBMODULEID
        );
        if (!submodule) {
          submodule = {
            SUBMODULEID: item.SUBMODULEID,
            SUBMODULENAME: item.SUBMODULENAME,
            MENUS: [],
          };
          module.SUBMODULES.push(submodule);
        }

        // Add menu to submodule
        submodule.MENUS.push({
          MENUID: item.MENUID,
          MENUNAME: item.MENUNAME,
          IMAGEPATH: item.IMAGEPATH,
          ORDER: item.ORDER,
        });
      });

      // console.log("json after grouping ", JSON.stringify(grouped, null, 2));

      setGroupedModuleSubmoduleMain(grouped);
    }
  }, [datagetAllMenuOfThisRole]);

  const [currentSubmodules, setCurrentSubmodules] = useState([]);
  useEffect(() => {
    if (groupedModuleSubmoduleMain && currentSelectedMouleObject?.MODULEID) {
      const matchedModule = groupedModuleSubmoduleMain.find(
        (item) => item.MODULEID === currentSelectedMouleObject.MODULEID
      );
      setCurrentSubmodules(matchedModule?.SUBMODULES || []);
    }
  }, [groupedModuleSubmoduleMain, currentSelectedMouleObject]);

  return token ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* 1. FIXED HEADER */}
      <div style={{ position: "relative", zIndex: 10 }}>
        <Header setCurrentSelectedMouleObject={setCurrentSelectedMouleObject} />
      </div>

      {/* 2. MAIN CONTENT AREA (No scroll here) */}
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          width: "100vw",
          overflow: "hidden",
        }}
        className="w-full"
      >
        {/* 3. SIDEBAR WITH INDEPENDENT SCROLL */}
        <div className="z-20 relative ">
          <Sidebar
            setIsModulePanelExpanded={setIsModulePanelExpanded}
            isModulePanelExpanded={isModulePanelExpanded}
            setCurrentHoveredLink={setCurrentHoveredLink}
            setCurrentHoveredLinkPositon={setCurrentHoveredLinkPositon}
            setCurrentSelectedMouleObject={setCurrentSelectedMouleObject}
            currentSelectedMouleObject={currentSelectedMouleObject}
            groupedModuleSubmoduleMain={groupedModuleSubmoduleMain}
          />
        </div>

        {/* 4. MAIN DASHBOARD AREA WITH INDEPENDENT SCROLL */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
          }}
          className=" relative"
        >
          {/* Actual Route Content */}
          <div>
            {/* <AutoLogoutAndGuard> */}
            <Outlet
              context={{
                currentSelectedMouleObject,
                groupedModuleSubmoduleMain,
                loadinggetAllMenuOfThisRole,
              }}
            />
            {/* </AutoLogoutAndGuard> */}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Navigate to="/" />
  );
};

export default ProtectedRouteLogin;
